import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import { FaArrowLeft, FaUserTie } from "react-icons/fa6";
// import logo from "../lava-care-logo.png";
import mtrLogo from "../mtr-logo.png";
import { MdOutlineWbSunny } from "react-icons/md";
import { IoMoonOutline } from "react-icons/io5";
import { AppContext } from "../contexts/AppContext";
// import { AuthContext } from "../contexts/AuthContext";
import { EMPOWER_LOGOUT_URL } from "../config";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { theme, toggleTheme } = useContext(AppContext);
  // const { user } = useContext(AuthContext);

  return (
    <nav
      data-testid="header-nav"
      className="bg-white border-b border-zinc-200 relative z-30"
      style={{ fontFamily: "'Chivo', sans-serif" }}
    >
      <div className="mx-auto px-6 py-3 flex justify-between items-center">
        {/* Brand */}
        <div className="flex items-center gap-3">
          <img
            src={mtrLogo}
            alt="MTR Logo"
            data-testid="mtr-logo"
            style={{ height: 56, width: 56, objectFit: 'contain', borderRadius: '50%' }}
          />
          <span
            data-testid="brand-title"
            className="text-lg font-black tracking-tight uppercase"
            style={{ color: '#09090B', letterSpacing: '-0.02em' }}
          >
            SOP Forecasting
          </span>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex relative justify-between items-center space-x-6">
          <li>
            <div className="profile_user flex items-center space-x-3">
              <div className="profile_user_name" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
                <span
                  data-testid="user-name"
                  className="font-semibold text-sm"
                  style={{ color: '#09090B' }}
                >
                  {/* {user?.employee_name} */}
                  Srijoy
                </span>
                <a href={EMPOWER_LOGOUT_URL}>
                  <button
                    data-testid="logout-button"
                    className="text-xs font-medium uppercase tracking-wider hover:text-blue-700 transition-colors"
                    style={{ color: '#A1A1AA' }}
                  >
                    Logout
                  </button>
                </a>
              </div>
              <div
                className="flex items-center justify-center border border-zinc-200 bg-zinc-50"
                style={{ width: 36, height: 36, color: '#002FA7' }}
              >
                <FaUserTie size={16} />
              </div>
            </div>
          </li>
          <li>
            <button
              data-testid="theme-toggle-button"
              onClick={toggleTheme}
              className="flex items-center p-2 hover:bg-zinc-100 transition-colors"
              style={{ color: '#52525B', border: 'none', background: 'none' }}
            >
              {theme === "light" ? <MdOutlineWbSunny size={18} /> : <IoMoonOutline size={18} />}
            </button>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden p-2 hover:bg-zinc-100 transition-colors"
          style={{ color: '#52525B' }}
        >
          {isOpen ? <FaArrowLeft /> : <AiOutlineMenu />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <ul
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-zinc-200 py-2 text-center space-y-2"
        >
          <li>
            <Link to="/" className="text-sm font-medium hover:text-blue-700 transition-colors" style={{ color: '#52525B' }}>
              Home
            </Link>
          </li>
        </ul>
      )}
    </nav>
  );
}
